module.exports = __webpack_public_path__ + "img/can.0a53ea78.svg";